/* jshint esversion:6 */
/* globals wafIgnoreInputs */

function getRouteFromUrl(url) {
    const href = String(url || window.location.href);
    const match = href.match(/[?&]route=([^&#]*)/);
    return match ? decodeURIComponent(match[1]) : '';
}

function b64(str){
    return btoa(unescape(encodeURIComponent(str)));
}

function hasWafRuleForRoute(route) {
    if (!Array.isArray(wafIgnoreInputs) || wafIgnoreInputs.length === 0){
        return false;
    }
    const currentRoute = (route || '').trim();
    for (const rule of wafIgnoreInputs) {
        const ruleRoute = (rule.route ?? '').trim();
        if (!ruleRoute || ruleRoute === currentRoute) {
            return true;
        }
    }
    return false;
}


function applyWafIgnoreInputs(requestData) {
    if (!Array.isArray(wafIgnoreInputs) || wafIgnoreInputs.length === 0) {
        return requestData;
    }

    const updatedData = { ...requestData };
    const encodedKeys = {};

    wafIgnoreInputs.forEach(function (rule) {
        if (!Object.prototype.hasOwnProperty.call(updatedData, rule.input_name)) {
            return;
        }

        if (encodedKeys[rule.input_name]) {
            return;
        }

        const requestValue = updatedData[rule.input_name];

        if (typeof requestValue !== 'string' || requestValue.trim() === '') {
            return;
        }

        let shouldEncode = false;

        if (rule.type === 'starts_with' && requestValue.startsWith(rule.ignore_input)) {
            shouldEncode = true;
        } else if (rule.type === 'contains' && requestValue.includes(rule.ignore_input)) {
            shouldEncode = true;
        }

        if (shouldEncode) {
            updatedData[rule.input_name] = b64(requestValue);
            encodedKeys[rule.input_name] = true;
        }
    });

    updatedData.waf_encoded_keys = encodedKeys;
    return updatedData;
}

function processFormDataWithWaf(formData) {
    try {
        if (formData instanceof FormData) {
            console.warn('FormData desteklenmiyor');
            return formData;
        }

        let requestData = formData;

        if (typeof requestData === 'string') {
            const parsedData = {};
            requestData.split('&').forEach(function(pair) {
                const parts = pair.split('=');
                const key = decodeURIComponent(parts[0] || '');
                const value = decodeURIComponent(parts[1] || '');
                if (key) parsedData[key] = value;
            });
            requestData = parsedData;
        }

        return applyWafIgnoreInputs(requestData);
    } catch (err) {
        console.warn('processFormDataWithWaf failed:', err);
        return formData;
    }
}

// --- AJAX Prefilter (POST) ---
$.ajaxPrefilter(function(options, originalOptions, jqXHR) {
    try {
        if ((originalOptions.type || '').toUpperCase() !== 'POST') {
            return;
        }
        if (!originalOptions.data){
            return;
        }
        if (originalOptions.data instanceof FormData) {
            return;
        }

        if (originalOptions.data && originalOptions.data._waf_processed) {
            return;
        }


        //Route kontrolü buradan yapılıyor
       const route = getRouteFromUrl(originalOptions.url || options.url);
       if (!hasWafRuleForRoute(route)) {
           return;
       }

        let processedData = processFormDataWithWaf(originalOptions.data);
        processedData._waf_processed = true;

        originalOptions.data = processedData;
        options.data = $.param(processedData);
    } catch (err) {
        console.warn('ajaxPrefilter failed:', err);
    }
});

// --- Form Submit ---
$(document).ready(function (){
    $('form').on('submit', function(e) {
        const form = $(this);

        if (form.data('waf-processed')) {
            return true;
        }

        if (!Array.isArray(wafIgnoreInputs) || wafIgnoreInputs.length === 0){
            return true;
        }

        //Route kontrolü buradan yapılıyor
        const route = getRouteFromUrl(form.attr('action'));
        if (!hasWafRuleForRoute(route)) {
            return true;
        }

        e.preventDefault();

        //Form verileri okunuyor
        const formData = {};
        form.serializeArray().forEach(f => formData[f.name] = f.value);

        //Waf uygulanıyor
        const processedData = processFormDataWithWaf(formData);

        Object.keys(processedData).forEach(key => {
            if (key === 'waf_encoded_keys' || key === '_waf_processed'){
                return;
            }
            if (processedData.waf_encoded_keys && processedData.waf_encoded_keys[key]) {
                const input = form.find(`[name="${key}"]`);
                input.prop('disabled', true);
                $('<input type="hidden">')
                    .attr('name', key)
                    .val(processedData[key])
                    .appendTo(form);
            }
        });

        if (processedData.waf_encoded_keys && Object.keys(processedData.waf_encoded_keys).length > 0) {
            form.find('input[name^="waf_encoded_keys"]').remove();
            Object.keys(processedData.waf_encoded_keys).forEach(key => {
                if (processedData.waf_encoded_keys[key]) {
                    $('<input type="hidden">')
                        .attr('name', `waf_encoded_keys[${key}]`)
                        .val('1')
                        .appendTo(form);
                }
            });
        }

        form.data('waf-processed', true);
        this.submit();
    });
});
